import usePools from '@/composables/pools/usePools';
import symbolKeys from '@/constants/symbol.keys';
import { safeInject } from '../inject';

const globalPoolsProvider = () => {
  const { pools, isLoading } = usePools({
    filterTokens: ref([]),
    sortField: ref('liquidity'),
    poolIds: ref([]),
    poolTypes: ref([]),
    poolAttributes: ref([]),
    poolCategories: ref([]),
    autoInjectTokens: false,
    first: 1000,
  });

  return {
    pools,
    isLoading,
  };
};

/**
 * Provider setup: response type + symbol.
 */
export type GlobalPoolsProviderResponse = ReturnType<
  typeof globalPoolsProvider
>;
export const GlobalPoolsProviderSymbol: InjectionKey<GlobalPoolsProviderResponse> =
  Symbol(symbolKeys.Providers.GlobalPools);

export function provideGlobalPools(): GlobalPoolsProviderResponse {
  const _provider = globalPoolsProvider();
  provide(GlobalPoolsProviderSymbol, _provider);
  return _provider;
}

export function useGlobalPools(): GlobalPoolsProviderResponse {
  return safeInject(GlobalPoolsProviderSymbol);
}
